import currency_symbols from "../utils/currencyCodes";

if ($(".js-recommended-products").length > 0) {
  const productId = $("#product-id").data("productId");

  $(".js-recommended-product-close").on("click", function () {
    $(".js-recommended-products").hide();
  });

  $.get(
    `/recommendations/products.json?product_id=${productId}&limit=3`,
    function (data) {
      if (data.products.length == 0) {
        return $(".js-recommended-products").hide();
      }

      data.products.map((product) => {
        let firstAvailable = product.variants.find((x) => x.available);
        if (firstAvailable === undefined) {
          firstAvailable = product.variants[0];
        }

        $(".js-recommended-products .cart-addon__body").html(`
        <div>
          <div class="cart-addon__product">
          <a class="cart-addon__product-image" href="${
            product.url.split("?")[0]
          }">
            <img class="lazyload" data-src="${product.featured_image}" alt="${
          product.title
        }">
          </a>
  
          <div class="cart-addon__content">
            <a class="cart-addon__link" href="${product.url.split("?")[0]}">
              <h6>${product.title}</h6>
  
              <p class="cart-addon__price price">
                <span class="price__amount">
                  <span class="money">
                    ${
                      window.Shopify.currency.active
                        ? currency_symbols[window.Shopify.currency.active]
                        : "£"
                    }
                    ${(firstAvailable.price / 100).toFixed(2)}
                  </span>
                </span>
              </p>
            </a>
            
            <a
              js-quick-add
              data-id="${firstAvailable.id}"
              href="#"
              class="btn-simple"
            >
              Add to bag
            </a>
          </div>
        </div>
        `);
      });
    }
  );
}
